import { render } from "./StepContratto.vue?vue&type=template&id=094eb22c"
import script from "./StepContratto.vue?vue&type=script&lang=js"
export * from "./StepContratto.vue?vue&type=script&lang=js"

import "./StepContratto.vue?vue&type=style&index=0&id=094eb22c&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__